import React, { FC, memo } from 'react';
import { Checkbox } from './styles';
import { Props } from './types';

const Toggle: FC<Props> = ({ ...rest }) => (
  <Checkbox type="checkbox" {...rest} />
);

export default memo(Toggle);
